<template>
  <div :class="success ?  'KnowledgeBaseAction' : 'KnowledgeBaseAction__error' ">
    <div class="KnowledgeBaseAction__header">
      <span>Knowledge Base Response</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="KnowledgeBaseAction__body">
        <div class="KnowledgeBaseActionOutput__answer"> {{ outputObject.answer }}</div>
        <div v-if="outputObject.references" class="KnowledgeBaseActionOutput__references_container">
          <h3 style="margin-bottom: 10px">References: </h3>
          <div class="KnowledgeBaseActionOutput__references" v-for="(reference, index) in outputObject.references" :key="index">
            <div class="reference_file">{{ reference.metadata.file_name || reference.metadata.name }}</div>
            <div class="reference_text">{{ reference.text }}</div>
          </div>
        </div>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="DefaultAction__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !success">
      <div class="KnowledgeBaseAction__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'knowledge-base-action-output',
  components: { },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import './index';
</style>
